import React, { createContext, useContext, useMemo, useState } from 'react';

import { DemoSessionConfig } from '../types/demo';

interface DemoSessionContextValue {
  session: DemoSessionConfig | null;
  setSession: (session: DemoSessionConfig | null) => void;
}

const DemoSessionContext = createContext<DemoSessionContextValue | undefined>(undefined);

export const DemoSessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [session, setSession] = useState<DemoSessionConfig | null>(null);
  const value = useMemo(() => ({ session, setSession }), [session]);
  return <DemoSessionContext.Provider value={value}>{children}</DemoSessionContext.Provider>;
};

export const useDemoSession = (): DemoSessionContextValue => {
  const ctx = useContext(DemoSessionContext);
  if (!ctx) throw new Error('useDemoSession must be used within DemoSessionProvider');
  return ctx;
};
